module.exports = __webpack_public_path__ + "static/img/tel.6d999d21.png";